export default __webpack_public_path__ + "static/media/arrow-single-left.3f159bc8.svg";